(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slideshow"] && !Shopify.designMode) return;
  try {
    
  class BannerSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-banner-track]');
      if (!this.track) return;

      this.slides = Array.from(this.querySelectorAll('[data-banner-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-banner-dot]'));
      this.count = this.slides.length;
      this.index = 0;
      this.timer = null;
      this.frame = null;
      this.focused = false;
      this.visible = true;
      this.editing = false;

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.interval = Math.max(1000, Number(this.dataset.interval) || 5000);
      this.autoplay = this.dataset.autoplay === 'true' && this.count > 1;
      this.style.setProperty('--banner-interval', this.interval + 'ms');

      this.track.addEventListener('scroll', () => this.schedule(), { passive: true });

      const prev = this.querySelector('[data-banner-prev]');
      const next = this.querySelector('[data-banner-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1, true));
      if (next) next.addEventListener('click', () => this.step(1, true));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index), true));
      });

      // No hover pause: a cursor resting on the banner when the page loads
      // would hold it forever. Keyboard focus and an active touch do pause it.
      this.addEventListener('focusin', (event) => {
        // Keyboard focus pauses (someone is reading or navigating); a mouse
        // click also focuses the arrow but must not freeze the show.
        this.focused = event.target.matches(':focus-visible');
        this.restart();
      });
      this.addEventListener('focusout', () => { this.focused = false; this.restart(); });
      this.track.addEventListener('pointerdown', () => { this.settleUntil = 0; this.stop(); }, { passive: true });
      this.track.addEventListener('pointerup', () => this.restart(), { passive: true });
      this.track.addEventListener('pointercancel', () => this.restart(), { passive: true });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.step(-1, true); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.step(1, true); }
      });

      document.addEventListener('visibilitychange', () => this.restart());
      this.reduceMotion.addEventListener('change', () => this.restart());

      // No point advancing a banner nobody can see.
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries.some((entry) => entry.isIntersecting);
          this.restart();
        }, { threshold: 0.25 });
        this.observer.observe(this);
      }

      // Slide widths change with the viewport; keep the current slide in place
      // rather than letting the track land between two of them.
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.goTo(this.index, false, 'auto'), 100);
      }, { passive: true });

      // Theme editor: clicking a slide block shows that slide and holds it.
      document.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest && event.target.closest('[data-banner-slide]');
        if (!slide || !this.contains(slide)) return;
        this.editing = true;
        this.goTo(this.slides.indexOf(slide), false, 'auto');
      });
      document.addEventListener('shopify:block:deselect', (event) => {
        if (!this.contains(event.target)) return;
        this.editing = false;
        this.restart();
      });

      this.sync();
      this.restart();
    }

    disconnectedCallback() {
      this.stop();
      if (this.observer) this.observer.disconnect();
    }

    canAutoplay() {
      return this.autoplay
        && !this.focused
        && !this.editing
        && this.visible
        && !document.hidden
        && !this.reduceMotion.matches;
    }

    restart() {
      this.stop();
      if (!this.canAutoplay()) return;
      // Warm the next image shortly before the advance — not at page load,
      // where it would compete with the first slide (the LCP) for bandwidth.
      this.warmTimer = window.setTimeout(
        () => this.warm((this.index + 1) % this.count),
        Math.max(0, this.interval - 1500)
      );
      this.timer = window.setTimeout(() => this.step(1, false), this.interval);
      // The ring around the active dot is a CSS animation the length of the
      // interval; re-adding the class restarts it in step with the timer.
      this.classList.remove('is-playing');
      void this.offsetWidth;
      this.classList.add('is-playing');
    }

    stop() {
      if (this.timer) window.clearTimeout(this.timer);
      if (this.warmTimer) window.clearTimeout(this.warmTimer);
      this.timer = null;
      this.warmTimer = null;
      this.classList.remove('is-playing');
    }

    step(delta, byUser) {
      this.goTo((this.index + delta + this.count) % this.count, byUser);
    }

    /* Adjacent moves glide; the wrap from last back to first would sweep every
       slide past at speed, so that one dips to black and jumps instead. */
    goTo(index, byUser, behavior) {
      if (!this.count) return;
      index = Math.max(0, Math.min(this.count - 1, index));
      const width = this.track.clientWidth;
      const distance = Math.abs(index - this.index);
      let mode = behavior || (distance > 1 ? 'jump' : 'smooth');
      if (this.reduceMotion.matches) mode = 'auto';

      this.warm(index);

      if (mode === 'jump') {
        this.track.classList.add('is-jumping');
        window.setTimeout(() => {
          // Assign scrollLeft rather than scrollTo: the most reliable way to
          // move a snapping track instantly on iOS. Checked once more a beat
          // later in case the browser snapped it back.
          this.track.scrollLeft = index * width;
          this.track.classList.remove('is-jumping');
          window.setTimeout(() => {
            if (Math.round(this.track.scrollLeft / this.track.clientWidth) !== index) {
              this.track.scrollLeft = index * this.track.clientWidth;
            }
          }, 60);
        }, 220);
      } else {
        // Scroll events fired mid-glide would read back the slide being left;
        // ignore them until the track has settled.
        if (mode === 'smooth') this.settleUntil = Date.now() + 700;
        this.track.scrollTo({ left: index * width, behavior: mode });
      }

      this.index = index;
      this.render();
      // Re-arm after every move, automatic ones included — otherwise autoplay
      // ran exactly once and stopped on the second slide.
      this.restart();
    }

    /* Fetch a slide's image before it is shown, so the advance never lands on
       an empty frame. Lazy slides otherwise only load once scrolled near. */
    warm(index) {
      const img = this.slides[index] && this.slides[index].querySelector('img[loading="lazy"]');
      if (img) img.loading = 'eager';
    }

    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.sync();
      });
    }

    /* The visitor swiped: read the index back from the scroll position. */
    sync() {
      const width = this.track.clientWidth;
      if (!width || Date.now() < (this.settleUntil || 0)) return;
      const index = Math.round(this.track.scrollLeft / width);
      if (index !== this.index) {
        this.index = index;
        this.render();
        this.restart();
        // The visitor is swiping: whatever comes next should already be loading.
        this.warm((index + 1) % this.count);
      }
    }

    render() {
      this.dots.forEach((dot, i) => dot.setAttribute('aria-selected', String(i === this.index)));
      this.slides.forEach((slide, i) => {
        const link = slide.querySelector('a.banner__frame');
        if (link) link.tabIndex = i === this.index ? 0 : -1;
      });
    }
  }

  if (!customElements.get('banner-slideshow')) {
    customElements.define('banner-slideshow', BannerSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      const wrapper = this.closest('[id^="shopify-section"]');
      this.sectionId = wrapper ? wrapper.id.replace('shopify-section-', '') : '';

      document.addEventListener('cart:open', () => this.open());
      document.addEventListener('cart:refresh', () => this.refresh());

      this.reconcile();

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-close]')) return this.close();

        const change = event.target.closest('[data-line-change]');
        if (change) return this.change(change.dataset.lineChange, Number(change.dataset.qty));

        const add = event.target.closest('[data-cart-add]');
        if (add) return this.add(add.dataset.cartAdd);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.hasAttribute('data-open')) this.close();
      });
    }

    /* Shopify keeps the cart in a first-party cookie that outlives the session,
       so a returning visitor still has their bag. Pages can be served from cache
       with a stale render though, so the count is checked against /cart.js once
       on load and the drawer re-rendered only when it disagrees. */
    async reconcile() {
      try {
        const cart = await fetch('/cart.js').then((r) => r.json());
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        const rendered = this.querySelectorAll('[data-line-key]').length;
        if (cart.items.length !== rendered) await this.refresh();
      } catch (error) {
        /* Offline or blocked: the server render stands. */
      }
    }

    open() {
      this.setAttribute('data-open', '');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      const close = this.querySelector('[data-cart-close]:not(.cd__overlay)');
      if (close) close.focus();
    }

    close() {
      this.removeAttribute('data-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    async add(id) {
      // Open on the current (possibly stale) contents right away rather than
      // waiting for add.js and the refresh to both resolve first — the
      // drawer appears instantly and its contents settle a moment later.
      this.open();
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      });
      await this.refresh();
    }

    async change(key, quantity) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      await this.refresh();
    }

    async refresh() {
      if (!this.sectionId) return;

      // Used to also fetch /cart.js in parallel purely to get item_count for
      // the header badge — a second full round trip for one number this
      // section's own markup already carries. Reading it off the fetched
      // markup itself (data-item-count) cuts this to the one request that
      // was always required, the section re-render.
      const markup = await fetch(`${window.location.pathname}?section_id=${this.sectionId}`).then((r) => r.text());
      const fresh = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-cart-drawer]');
      if (!fresh) return;

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { item_count: Number(fresh.dataset.itemCount || 0) },
      }));

      const wasOpen = this.hasAttribute('data-open');
      this.innerHTML = fresh.innerHTML;
      if (wasOpen) this.open();
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  /* No manual AddToCart tracking here on purpose. Meta and Google are both
     installed as native Shopify sales channels (Settings → Customer events:
     Facebook & Instagram and Google & YouTube, both Server + Web) — their
     sandboxed pixels already track product_added_to_cart independently,
     server-side included, for both add paths below (/cart/add.js is the
     standard endpoint Shopify's own event tracking watches). Firing it again
     from here would double-count, not fill a gap — see theme.liquid for the
     one thing native genuinely can't cover (checkout-stage events, because
     Shopify's own checkout never starts under Fastrr). */

  /* Any add-to-cart form on the page opens the drawer rather than loading /cart,
     which is how the previous storefront behaved. */
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    event.preventDefault();
    await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:open'));
  });

  /* Checkout click handling lives here, not in checkout-button.liquid, on
     purpose. That snippet only renders once cart.item_count > 0, so on a
     first add-to-cart from an empty cart its {% javascript %} never loads at
     all — and CartDrawer.refresh() injects the newly-rendered button via
     this.innerHTML, which browsers never execute embedded <script> tags
     from (a deliberate DOM/HTML spec rule, not a bug). Net effect: a
     completely dead click, no error, first time only — worked again on any
     later click because by then a real page load had already happened with
     items already in the cart, so the snippet (and its script) loaded
     normally. cart-drawer.liquid is unconditionally rendered on every page
     via footer-group.json, so listening here means this always exists
     regardless of cart state or how the button's markup arrived. Delegated
     on document, not this cart-drawer element, because main-cart.liquid
     renders its own checkout-button outside this element's DOM entirely. */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-checkout-button]');
    if (!button) return;

    const read = (selector) => {
      const node = document.querySelector(selector);
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }
    };

    const payload = read('[data-checkout-payload]');
    if (!payload || !payload.products.length) return;

    // Meta InitiateCheckout, fired at the checkout click exactly as the previous
    // storefront did (shiprocket-cart-checkout-button.tsx:35). This is the one
    // event the Meta channel app cannot fire for us: its own InitiateCheckout
    // rides on Shopify's checkout_started, and with Fastrr Shopify's checkout
    // never starts. Everything after this click is Fastrr's, including Purchase.
    //
    // GA4 begin_checkout is new — the previous storefront never sent it (it had
    // no GA4 ecommerce events at all) — added manually here for the same reason
    // Meta's is manual: Shopify's checkout never starts, so GA4's own channel
    // integration has nothing to hang begin_checkout off of either.
    const tracking = read('[data-checkout-tracking]');
    if (typeof window.fbq === 'function' && tracking) {
      window.fbq('track', 'InitiateCheckout', {
        currency: tracking.currency,
        value: tracking.value,
      });
    }
    if (typeof window.gtag === 'function' && tracking) {
      window.gtag('event', 'begin_checkout', {
        currency: tracking.currency,
        value: tracking.value,
        items: tracking.items,
      });
    }

    const originalLabel = button.innerHTML;
    const deadline = Date.now() + 15000;

    const attempt = () => {
      if (window.shiprocketCheckoutEvents?.buyDirect) {
        window.shiprocketCheckoutEvents.buyDirect(payload);
        return;
      }
      if (Date.now() > deadline) {
        button.disabled = false;
        button.innerHTML = originalLabel;
        alert(button.dataset.labelError || 'Unable to start checkout. Please try again.');
        return;
      }
      button.disabled = true;
      button.textContent = button.dataset.labelLoading || 'Opening checkout…';
      setTimeout(attempt, 150);
    };
    attempt();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.toggles = Array.from(this.querySelectorAll('[data-nav-toggle]'));
      this.drawer = this.querySelector('#nav-drawer');

      if (this.toggles.length && this.drawer) {
        this.toggles.forEach((toggle) => {
          toggle.addEventListener('click', () => this.setOpen(!this.drawer.hasAttribute('data-open')));
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.drawer.hasAttribute('data-open')) this.setOpen(false);
        });
        window.matchMedia('(min-width: 900px)').addEventListener('change', (event) => {
          if (event.matches) this.setOpen(false);
        });
      }

      // Desktop dropdowns: aria-expanded is the single source of truth the
      // CSS keys off (.nav__trigger[aria-expanded='true'] + .nav__dropdown),
      // driven by hover AND focus so keyboard users reach it too — tabbing
      // onto the trigger link reveals the dropdown before Enter is pressed,
      // so the next Tab lands inside it instead of skipping straight past.
      this.navItems = Array.from(this.querySelectorAll('[data-nav-item]'));
      this.navItems.forEach((item) => {
        const trigger = item.querySelector('[data-nav-trigger]');
        if (!trigger) return;
        let closeTimer;
        const open = () => {
          clearTimeout(closeTimer);
          trigger.setAttribute('aria-expanded', 'true');
        };
        const close = () => {
          // Delayed, not immediate: without it, moving the mouse from the
          // trigger down into the dropdown crosses a gap and closes it
          // before the pointer ever reaches the links inside.
          closeTimer = window.setTimeout(() => trigger.setAttribute('aria-expanded', 'false'), 150);
        };
        item.addEventListener('mouseenter', open);
        item.addEventListener('mouseleave', close);
        item.addEventListener('focusin', open);
        item.addEventListener('focusout', (event) => {
          if (!item.contains(event.relatedTarget)) close();
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        this.navItems.forEach((item) => {
          const trigger = item.querySelector('[data-nav-trigger]');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        });
      });

      // Hide on scroll (section setting): the bar slides up as the visitor
      // scrolls down and returns the moment they scroll back up, so the
      // sticky CTA at the foot and the header never box in a small screen.
      if (this.dataset.hideOnScroll === 'true') {
        const wrapper = this.closest('.nav-section');
        let last = window.scrollY;
        let ticking = false;
        window.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            ticking = false;
            const y = window.scrollY;
            const drawerOpen = this.drawer && this.drawer.hasAttribute('data-open');
            if (!drawerOpen && y > last && y > 120) {
              wrapper.setAttribute('data-nav-hidden', '');
            } else if (y < last - 4 || y <= 0) {
              wrapper.removeAttribute('data-nav-hidden');
            }
            last = y;
          });
        }, { passive: true });
      }

      this.querySelectorAll('[data-cart-open]').forEach((button) => {
        button.addEventListener('click', () => {
          document.dispatchEvent(new CustomEvent('cart:open'));
        });
      });

      document.addEventListener('cart:updated', (event) => {
        const count = event.detail && event.detail.item_count;
        if (typeof count !== 'number') return;
        this.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = String(count);
          el.hidden = count === 0;
        });
      });
    }

    setOpen(open) {
      if (open) {
        this.drawer.removeAttribute('inert');
        // Set before the transition starts, so the panel is already
        // findable when the transition fires the focus below.
        this.drawer.setAttribute('data-open', '');
      } else {
        this.drawer.removeAttribute('data-open');
        // inert waits for the close transition to finish, so the panel
        // stays focusable/visible while it's still sliding away.
        window.setTimeout(() => this.drawer.setAttribute('inert', ''), 300);
      }
      document.documentElement.style.overflow = open ? 'hidden' : '';
      this.toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(open)));
      if (open) {
        const close = this.drawer.querySelector('.nav__drawer-close');
        if (close) close.focus();
      } else if (this.toggles[0]) {
        this.toggles[0].focus();
      }
    }
  }

  if (!customElements.get('site-header')) {
    customElements.define('site-header', SiteHeader);
  }

  /* Megamenu carousel: progress bar and arrows at the foot, shown only when
     the row overflows. Re-checked on resize because cards-per-row changes
     by band. */
  class MegaRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-mm-track]');
      if (!this.track) return;
      this.prev = this.querySelector('[data-mm-prev]');
      this.next = this.querySelector('[data-mm-next]');

      if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
      if (this.next) this.next.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.sync(), 100);
      }, { passive: true });

      // The bag button flips to a tick once the drawer has taken the item.
      this.querySelectorAll('[data-mmc-bag]').forEach((button) => {
        button.closest('form').addEventListener('submit', () => {
          button.setAttribute('data-added', '');
          window.setTimeout(() => button.removeAttribute('data-added'), 2000);
        });
      });

      this.sync();
    }

    step(direction) {
      const item = this.track.querySelector('.mm__item');
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: (item.getBoundingClientRect().width + gap) * direction, behavior: 'smooth' });
    }

    sync() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const none = max <= 1;
      const foot = this.querySelector('[data-mm-foot]');
      if (foot) foot.hidden = none;
      if (none) return;
      const fill = this.querySelector('[data-mm-progress]');
      if (fill) {
        const share = (this.track.scrollLeft + this.track.clientWidth) / this.track.scrollWidth;
        fill.style.transform = `scaleX(${Math.max(0, Math.min(1, share)).toFixed(4)})`;
      }
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 1;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max - 1;
    }
  }

  if (!customElements.get('mega-rail')) {
    customElements.define('mega-rail', MegaRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-showcase"] && !Shopify.designMode) return;
  try {
    
  class IngredientShowcase extends HTMLElement {
    connectedCallback() {
      this.rows = Array.from(this.querySelectorAll('[data-ingx-row]'));
      this.triggers = Array.from(this.querySelectorAll('[data-ingx-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-ingx-panel]'));
      this.backgrounds = Array.from(this.querySelectorAll('[data-ingx-bg]'));
      this.detail = this.querySelector('[data-ingx-detail]');
      this.mobile = window.matchMedia('(max-width: 767px)');
      if (!this.triggers.length) return;

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.select(trigger.dataset.ingxTrigger));
      });

      this.querySelectorAll('[data-ingx-learn]').forEach((button) => {
        button.addEventListener('click', () => {
          this.select(button.dataset.ingxLearn);
          this.openSheet();
        });
      });

      this.querySelectorAll('[data-ingx-close]').forEach((button) => {
        button.addEventListener('click', () => this.closeSheet());
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeSheet();
      });

      this.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        const current = this.triggers.indexOf(document.activeElement);
        if (current === -1) return;
        event.preventDefault();
        const step = event.key === 'ArrowDown' ? 1 : -1;
        const next = (current + step + this.triggers.length) % this.triggers.length;
        this.triggers[next].focus();
        this.select(this.triggers[next].dataset.ingxTrigger);
      });

      // The sheet only exists under 768; leaving that band closes it.
      this.mobile.addEventListener('change', (event) => {
        if (!event.matches) this.closeSheet();
      });
    }

    select(index) {
      this.rows.forEach((el) => el.classList.toggle('is-active', el.dataset.ingxRow === index));
      this.triggers.forEach((el) => {
        el.setAttribute('aria-selected', String(el.dataset.ingxTrigger === index));
      });
      this.panels.forEach((el) => {
        const on = el.dataset.ingxPanel === index;
        el.classList.toggle('is-active', on);
        el.hidden = !on;
      });
      this.backgrounds.forEach((el) => {
        el.classList.toggle('is-active', el.dataset.ingxBg === index);
      });
    }

    openSheet() {
      if (!this.detail || !this.mobile.matches) return;
      this.detail.classList.add('is-open');
      this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      const close = this.detail.querySelector('.ingx__close');
      if (close) close.focus();
    }

    closeSheet() {
      if (!this.detail || !this.detail.classList.contains('is-open')) return;
      this.detail.classList.remove('is-open');
      document.body.style.overflow = this.previousOverflow || '';
    }
  }

  if (!customElements.get('ingredient-showcase')) {
    customElements.define('ingredient-showcase', IngredientShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  /* Table of contents from the body's H2s. Shopify's editor never gives
     headings ids, so they're assigned here (slug of the text, de-duplicated)
     before the list is built — which also makes the ids linkable from
     elsewhere. Stays hidden below two headings: a one-item contents list is
     noise, not navigation. */
  class PostToc extends HTMLElement {
    connectedCallback() {
      const body = document.querySelector('[data-post-body]');
      const list = this.querySelector('[data-toc-list]');
      if (!body || !list) return;

      const headings = Array.from(body.querySelectorAll('h2'));
      if (headings.length < 2) return;

      const used = new Set();
      headings.forEach((heading) => {
        const text = heading.textContent.trim();
        if (!heading.id) {
          const base = text.toLowerCase().replace(/[^\w\s-]/g, '').trim().replace(/\s+/g, '-').replace(/-+/g, '-') || 'section';
          let id = base;
          let n = 2;
          while (used.has(id) || document.getElementById(id)) id = `${base}-${n++}`;
          heading.id = id;
        }
        used.add(heading.id);

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = text;
        item.appendChild(link);
        list.appendChild(item);
      });

      this.hidden = false;

      // A hash that arrived before these ids existed had nothing to land on.
      if (window.location.hash) {
        const target = document.getElementById(window.location.hash.slice(1));
        if (target) target.scrollIntoView();
      }
    }
  }

  if (!customElements.get('post-toc')) {
    customElements.define('post-toc', PostToc);
  }

  /* Tables come straight from the editor with no wrapper, so a wide one
     would push the page sideways on a phone. Each is wrapped in a
     horizontally scrolling div; the table itself stays a normal table and
     is always shown in full. Independent of the TOC above so it runs
     whether or not the contents list is enabled. */
  const wrapPostTables = () => {
    document.querySelectorAll('[data-post-body] table').forEach((table) => {
      if (table.parentElement && table.parentElement.classList.contains('post__table-wrap')) return;
      const wrap = document.createElement('div');
      wrap.className = 'post__table-wrap';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapPostTables);
  } else {
    wrapPostTables();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  /* Search, sort and "Show more" over the cards already on the page. The
     pristine state — empty search, newest first — is exactly what the
     server rendered: original order, the first page-size cards visible.
     Anything else filters and reorders the same <li>s in place, and
     "Show more" reveals the next page-size of whatever currently
     matches. */
  class BlogHub extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-hub-grid]');
      if (!this.grid) return;

      this.cards = Array.from(this.grid.children);
      this.pageSize = Number(this.dataset.pageSize) || 6;
      this.shown = this.pageSize;

      this.controls = this.querySelector('[data-hub-controls]');
      this.search = this.querySelector('[data-hub-search]');
      this.sort = this.querySelector('[data-hub-sort]');
      this.status = this.querySelector('[data-hub-status]');
      this.more = this.querySelector('[data-hub-more]');

      if (this.controls) {
        this.controls.hidden = false;
        this.controls.addEventListener('submit', (event) => event.preventDefault());
      }
      if (this.search) this.search.addEventListener('input', () => this.reset());
      if (this.sort) this.sort.addEventListener('change', () => this.reset());
      if (this.more) {
        this.more.addEventListener('click', () => {
          this.shown += this.pageSize;
          this.render(true);
        });
      }

      // A browser may restore typed text on back/forward; reflect it.
      if ((this.search && this.search.value) || (this.sort && this.sort.value !== 'newest')) this.reset();
    }

    matches() {
      const query = this.search ? this.search.value.trim().toLowerCase() : '';
      let list = this.cards.filter((card) => !query || (card.dataset.search || '').includes(query));

      const order = this.sort ? this.sort.value : 'newest';
      if (order === 'oldest') {
        list = list.slice().reverse();
      } else if (order === 'az') {
        list = list.slice().sort((a, b) => (a.dataset.title || '').localeCompare(b.dataset.title || ''));
      }

      return { query, list, pristine: !query && order === 'newest' };
    }

    render(focusNew) {
      const { query, list, pristine } = this.matches();

      // Appending in order moves the nodes; non-matching cards stay where
      // they are, hidden.
      (pristine ? this.cards : list).forEach((card) => this.grid.appendChild(card));

      const visible = new Set(list.slice(0, this.shown));
      let firstNew = null;
      this.cards.forEach((card) => {
        const show = visible.has(card);
        if (focusNew && show && card.hidden && !firstNew) firstNew = card;
        card.hidden = !show;
      });

      if (this.status) {
        if (!list.length) {
          this.status.textContent = (this.dataset.labelNoMatch || '').replace('__QUERY__', query);
          this.status.hidden = false;
        } else if (!pristine) {
          this.status.textContent = list.length === 1
            ? this.dataset.labelResultOne
            : (this.dataset.labelResults || '').replace('__COUNT__', String(list.length));
          this.status.hidden = false;
        } else {
          this.status.hidden = true;
        }
      }

      if (this.more) this.more.hidden = list.length <= this.shown;

      // Move keyboard focus onto the first newly shown card, so "Show more"
      // actually shows more for someone who can't see the page grow.
      if (firstNew) {
        const link = firstNew.querySelector('.hub__name a');
        if (link) link.focus();
      }
    }

    reset() {
      this.shown = this.pageSize;
      this.render(false);
    }
  }

  if (!customElements.get('blog-hub')) {
    customElements.define('blog-hub', BlogHub);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CartPage extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const change = event.target.closest('[data-line-change]');
        if (!change) return;
        this.change(change.dataset.lineChange, Number(change.dataset.qty));
      });
    }

    async change(key, quantity) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      window.location.reload();
    }
  }

  if (!customElements.get('cart-page')) {
    customElements.define('cart-page', CartPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-autosubmit]');
    if (select) select.form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class VariantSelector extends HTMLElement {
    connectedCallback() {
      const node = this.querySelector('[data-variant-data]');
      if (!node) return;
      try {
        this.variants = JSON.parse(node.textContent);
      } catch (error) {
        return;
      }

      this.addEventListener('change', () => this.select());
    }

    select() {
      const chosen = Array.from(this.querySelectorAll('.vsel__input:checked'))
        .sort((a, b) => Number(a.dataset.position) - Number(b.dataset.position))
        .map((input) => input.value);

      const match = this.variants.find((v) => v.options.every((o, i) => o === chosen[i]));
      if (!match) return;

      const field = document.querySelector('[data-variant-id]');
      if (field) field.value = match.id;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);

      document.dispatchEvent(new CustomEvent('variant:changed', { detail: match }));
    }
  }

  if (!customElements.get('variant-selector')) {
    customElements.define('variant-selector', VariantSelector);
  }

  class OfferCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-poff-viewport]');
      this.dots = Array.from(this.querySelectorAll('[data-poff-dot]'));
      if (!this.viewport) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.dataset.poffDot);
          const card = this.viewport.querySelectorAll('.offc')[index];
          if (card) card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
      });

      if (this.dots.length) {
        this.viewport.addEventListener('scroll', () => {
          if (this.pending) return;
          this.pending = true;
          requestAnimationFrame(() => {
            this.pending = false;
            this.sync();
          });
        }, { passive: true });
        this.sync();
      }
    }

    sync() {
      const cards = Array.from(this.viewport.querySelectorAll('.offc'));
      const centre = this.viewport.scrollLeft + this.viewport.clientWidth / 2;
      let active = 0;
      let bestDistance = Infinity;
      cards.forEach((card, index) => {
        const distance = Math.abs(centre - (card.offsetLeft + card.clientWidth / 2));
        if (distance < bestDistance) {
          bestDistance = distance;
          active = index;
        }
      });
      this.dots.forEach((dot, index) => dot.toggleAttribute('data-active', index === active));
    }
  }

  if (!customElements.get('offer-carousel')) {
    customElements.define('offer-carousel', OfferCarousel);
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-copy]');
    if (!button) return;
    const label = button.querySelector('[data-copy-label]');
    try {
      await navigator.clipboard.writeText(button.dataset.copy);
      if (label) {
        const previous = label.textContent;
        label.textContent = 'Copied';
        setTimeout(() => { label.textContent = previous; }, 1600);
      }
    } catch (error) {
      /* Clipboard unavailable: the code is on screen to read. */
    }
  });

  /* Quantity steppers, including the mirrored pair in the fixed bar. */
  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-qty-step]');
    if (step) {
      const form = document.getElementById(step.dataset.qtyTarget || 'pdp-form');
      const input = form && form.querySelector('input[name="quantity"]');
      if (!input) return;
      const next = Math.max(1, Number(input.value || 1) + Number(step.dataset.qtyStep));
      input.value = next;
      document.querySelectorAll('[data-qty-mirror]').forEach((el) => { el.textContent = next; });
      return;
    }

    const proxy = event.target.closest('[data-submit-form]');
    if (proxy) {
      const form = document.getElementById(proxy.dataset.submitForm);
      if (form) form.requestSubmit();
    }
  });

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.strip = this.querySelector('[data-strip]');
      if (!this.strip) return;
      this.thumbs = Array.from(this.querySelectorAll('.pgal__thumb'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.frames = Array.from(this.querySelectorAll('.pgal__frame'));
      this.active = -1;

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = Number(thumb.dataset.index);
          this.strip.scrollTo({ left: index * this.strip.clientWidth, behavior: 'smooth' });
        });
      });

      this.strip.addEventListener('scroll', () => {
        if (this.pending) return;
        this.pending = true;
        requestAnimationFrame(() => {
          this.pending = false;
          this.sync();
        });
      });

      this.sync();
    }

    sync() {
      const width = this.strip.clientWidth;
      if (!width) return;
      const index = Math.round(this.strip.scrollLeft / width);
      this.thumbs.forEach((thumb, i) => {
        thumb.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      this.dots.forEach((dot, i) => {
        dot.toggleAttribute('data-active', i === index);
      });
      if (index !== this.active) {
        this.active = index;
        this.frames.forEach((frame, i) => (i === index ? this.playFrame(frame) : this.pauseFrame(frame)));
      }
    }

    /* A video slide plays, muted, as soon as the strip lands on it; the
       <video> element only exists from that moment, with the smallest MP4.
       When it ends, the strip moves on to the next slide. */
    playFrame(frame) {
      const host = frame.querySelector('[data-gal-video-host]');
      if (!host || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let video = host.querySelector('video');
      if (!video) {
        let sources = null;
        try { sources = JSON.parse(frame.dataset.galVideo); } catch (e) { return; }
        if (!sources || !sources.sd) return;
        video = document.createElement('video');
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.src = sources.hd || sources.sd;
        video.addEventListener('ended', () => {
          const next = this.frames.indexOf(frame) + 1;
          if (next < this.frames.length) {
            this.strip.scrollTo({ left: next * this.strip.clientWidth, behavior: 'smooth' });
          }
        });
        host.appendChild(video);
      }
      video.currentTime = 0;
      video.play()
        .then(() => host.setAttribute('data-playing', ''))
        .catch(() => host.removeAttribute('data-playing'));
    }

    pauseFrame(frame) {
      const host = frame.querySelector('[data-gal-video-host]');
      const video = host && host.querySelector('video');
      if (!video) return;
      video.pause();
      host.removeAttribute('data-playing');
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-gallery"] && !Shopify.designMode) return;
  try {
    
  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-mg-viewport]');
      if (!this.viewport) return;

      this.cards = Array.from(this.querySelectorAll('[data-mg-card]'));
      this.slots = this.cards.map((card) => card.parentElement);
      this.count = Number(this.dataset.mgCount) || 0;
      this.frame = null;

      this.viewport.addEventListener('scroll', () => this.schedule(), { passive: true });
      // Sizes change at the breakpoint, so re-centre rather than just re-measure.
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.centre(), 150);
      }, { passive: true });

      this.querySelectorAll('[data-mg-mute]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          this.toggleMute(button);
        });
      });

      // Start centred on the first tile of the middle pass, so there is runway
      // in both directions and the strip opens aligned.
      requestAnimationFrame(() => this.centre());
    }

    /* One pass measured from real slot positions. scrollWidth cannot be used:
       it includes the centring padding, so a third of it never lands on a tile. */
    segment() {
      if (!this.count || this.slots.length <= this.count) return 0;
      return this.slots[this.count].offsetLeft - this.slots[0].offsetLeft;
    }

    centre() {
      const segment = this.segment();
      if (segment > 0) this.viewport.scrollLeft = segment;
      this.active = null;
      this.update();
    }

    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.wrap();
        this.update();
      });
    }

    wrap() {
      const segment = this.segment();
      if (segment <= 0) return;
      if (this.viewport.scrollLeft >= segment * 2) this.viewport.scrollLeft -= segment;
      else if (this.viewport.scrollLeft <= 0) this.viewport.scrollLeft += segment;
    }

    nearest() {
      const centre = this.viewport.scrollLeft + this.viewport.clientWidth / 2;
      let best = 0;
      let bestDistance = Infinity;
      this.slots.forEach((slot, index) => {
        const cardCentre = slot.offsetLeft + slot.clientWidth / 2;
        const distance = Math.abs(centre - cardCentre);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = index;
        }
      });
      return best;
    }

    update() {
      const active = this.nearest();
      if (active === this.active) return;
      this.active = active;

      this.cards.forEach((card, index) => {
        const isActive = index === active;
        card.classList.toggle('is-active', isActive);
        card.classList.toggle('is-before', !isActive && index < active);
        card.classList.toggle('is-after', !isActive && index > active);

        const video = card.querySelector('video');
        if (!video) return;

        if (isActive) {
          video.play().catch(() => {});
        } else {
          video.pause();
          // A tile leaving the centre gives up its audio.
          video.muted = true;
          const button = card.querySelector('[data-mg-mute]');
          if (button) button.setAttribute('aria-pressed', 'true');
        }
      });
    }

    toggleMute(button) {
      const card = button.closest('[data-mg-card]');
      const video = card && card.querySelector('video');
      if (!video) return;

      // Only one tile may be unmuted at a time.
      if (video.muted) {
        this.cards.forEach((other) => {
          const otherVideo = other.querySelector('video');
          if (otherVideo && otherVideo !== video) {
            otherVideo.muted = true;
            const otherButton = other.querySelector('[data-mg-mute]');
            if (otherButton) otherButton.setAttribute('aria-pressed', 'true');
          }
        });
      }

      video.muted = !video.muted;
      if (!video.muted) video.play().catch(() => {});
      button.setAttribute('aria-pressed', String(video.muted));
    }
  }

  if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', MediaGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-success"]) return;
  try {
    
  (() => {
    const holder = document.querySelector('[data-order-ref]');
    if (!holder) return;

    const params = new URLSearchParams(window.location.search);
    const number = params.get('order_number');
    const reference = params.get('order_ref') || params.get('order_id') || params.get('oid');
    const value = number || reference;
    if (!value) return;

    holder.querySelector('[data-order-ref-label]').textContent =
      (number ? holder.dataset.labelNumber : holder.dataset.labelRef) + ' ';
    holder.querySelector('[data-order-ref-value]').textContent = value;
    holder.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story"] && !Shopify.designMode) return;
  try {
    
  class OurStory extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.ost__scroll');
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      if (!this.scroller || this.panels.length === 0) return;

      this.desktop = window.matchMedia('(min-width: 900px)');
      this.onScroll = this.onScroll.bind(this);
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            window.addEventListener('scroll', this.onScroll, { passive: true });
            this.onScroll();
          } else {
            window.removeEventListener('scroll', this.onScroll);
          }
        });
      });
      this.observer.observe(this);
      this.desktop.addEventListener('change', () => this.onScroll());
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.observer) this.observer.disconnect();
    }

    onScroll() {
      if (this.pending) return;
      this.pending = true;
      requestAnimationFrame(() => {
        this.pending = false;
        if (!this.desktop.matches) {
          this.panels.forEach((p) => p.style.removeProperty('--p'));
          return;
        }
        const box = this.scroller.getBoundingClientRect();
        const travel = box.height - window.innerHeight;
        const progress = travel > 0 ? Math.min(Math.max(-box.top / travel, 0), 1) : 0;
        const total = this.panels.length;
        const span = 1 / total;
        this.panels.forEach((panel, i) => {
          // Each panel owns the slice [i/total, (i+1)/total] of the total
          // scroll; outside its own slice this clamps to 0 (not yet its
          // turn — fully visible) or 1 (its turn passed — fully wiped),
          // exactly like Framer Motion's useTransform clamping outside its
          // input range.
          const local = (progress - i * span) / span;
          panel.style.setProperty('--p', String(Math.min(Math.max(local, 0), 1)));
        });
      });
    }
  }

  if (!customElements.get('our-story')) {
    customElements.define('our-story', OurStory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"]) return;
  try {
    
  class BeforeAfter extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-ba-input]');
      if (!this.input) return;
      this.input.addEventListener('input', () => this.apply());
      this.apply();
    }

    apply() {
      // Set once on the root: the clip layer, the divider and the handle
      // all read the same custom property via inheritance, so nothing can
      // drift out of sync with the other.
      this.style.setProperty('--split', `${this.input.value}%`);
    }
  }

  if (!customElements.get('before-after')) {
    customElements.define('before-after', BeforeAfter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"]) return;
  try {
    
  class ProductRelated extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.querySelector('.prel__item')) return;
      fetch(this.dataset.url)
        .then((r) => r.text())
        .then((text) => {
          const fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('product-related');
          if (fresh) this.innerHTML = fresh.innerHTML;
        })
        .catch(() => {});
    }
  }

  if (!customElements.get('product-related')) {
    customElements.define('product-related', ProductRelated);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-steps"] && !Shopify.designMode) return;
  try {
    
  /* Identical pattern to visual-breaker.liquid's film-player — copied, not
     shared, because that one manages two video slots (mobile/wide) and this
     one manages exactly one; a shared abstraction for a single button click
     handler isn't worth the indirection. */
  class StepsMedia extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-steps-mute]');
      this.label = this.querySelector('[data-steps-mute-label]');
      this.icon = this.querySelector('.psteps__mute-icon');
      if (!this.button) return;

      const video = this.querySelector('video');
      if (!video) return;

      this.button.addEventListener('click', () => {
        video.muted = !video.muted;
        if (!video.muted) video.play().catch(() => {});
        const muted = video.muted;
        this.button.setAttribute('aria-pressed', String(muted));
        if (this.icon) this.icon.textContent = muted ? '🔇' : '🔊';
        if (this.label) {
          this.label.textContent = muted
            ? this.label.dataset.unmute || 'Unmute video'
            : this.label.dataset.mute || 'Mute video';
        }
      });
    }
  }

  if (!customElements.get('steps-media')) {
    customElements.define('steps-media', StepsMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ritual-steps"] && !Shopify.designMode) return;
  try {
    
  /* The advance control from the previous storefront: each card carries a
     chevron that brings the next step into view, wrapping at the end. */
  class RitualSteps extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.step'));
      this.querySelectorAll('[data-step-next]').forEach((button, index) => {
        button.addEventListener('click', () => {
          const next = this.cards[(index + 1) % this.cards.length];
          if (next) next.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
      });
    }
  }

  if (!customElements.get('ritual-steps')) {
    customElements.define('ritual-steps', RitualSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-overlay"]) return;
  try {
    
  class SearchOverlay extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-panel]');
      this.input = this.querySelector('[data-input]');
      this.results = this.querySelector('[data-results]');
      this.recommended = this.querySelector('[data-recommended]');
      this.form = this.querySelector('[data-form]');
      if (!this.panel || !this.input) return;

      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-search-open]')) {
          event.preventDefault();
          this.open();
        } else if (this.contains(event.target) && event.target.closest('[data-close]')) {
          this.close();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.panel.hasAttribute('data-open')) this.close();
      });

      this.input.addEventListener('input', () => this.query());
      this.form.addEventListener('submit', () => this.close());
    }

    open() {
      this.panel.removeAttribute('inert');
      this.panel.setAttribute('data-open', '');
      document.documentElement.style.overflow = 'hidden';
      // Matches the source: focus lands 180ms after opening, once the sheet is in place.
      window.setTimeout(() => this.input.focus(), 180);
    }

    close() {
      this.panel.removeAttribute('data-open');
      // inert waits for the close transition (300ms enter / 200ms leave —
      // 200ms here) so the sheet stays focusable while it's still fading out.
      window.setTimeout(() => this.panel.setAttribute('inert', ''), 200);
      document.documentElement.style.overflow = '';
      window.clearTimeout(this.timer);
      if (this.controller) this.controller.abort();
      this.results.innerHTML = '';
      this.input.value = '';
      if (this.recommended) this.recommended.hidden = false;
    }

    query() {
      const terms = this.input.value.trim();
      window.clearTimeout(this.timer);
      if (this.controller) this.controller.abort();

      if (!terms) {
        this.results.innerHTML = '';
        if (this.recommended) this.recommended.hidden = false;
        return;
      }

      // Matches the source: recommended products only ever showed while the
      // query box was empty.
      if (this.recommended) this.recommended.hidden = true;

      // Stale results are cleared immediately, so a slow response for an older
      // query can never repaint over a newer one.
      this.results.innerHTML = '<p class="so__note">' + this.dataset.searching + '</p>';

      this.controller = new AbortController();
      const signal = this.controller.signal;

      this.timer = window.setTimeout(async () => {
        const url = this.dataset.url
          + '?q=' + encodeURIComponent(terms)
          + '&resources[type]=product&resources[limit]=6'
          + '&section_id=predictive-search';
        try {
          const response = await fetch(url, { signal });
          if (!response.ok) throw new Error(String(response.status));
          this.results.innerHTML = await response.text();
        } catch (error) {
          if (!signal.aborted) this.results.innerHTML = '';
        }
      }, 220);
    }
  }

  if (!customElements.get('search-overlay')) {
    customElements.define('search-overlay', SearchOverlay);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-ritual"] && !Shopify.designMode) return;
  try {
    
  class ProductRail extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-rail-viewport]');
      if (!this.viewport) return;

      this.foot = this.querySelector('[data-rail-foot]');
      this.fill = this.querySelector('[data-rail-progress]');
      this.prev = this.querySelector('[data-rail-prev]');
      this.next = this.querySelector('[data-rail-next]');

      if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
      if (this.next) this.next.addEventListener('click', () => this.step(1));

      this.viewport.addEventListener('scroll', () => {
        if (this.pending) return;
        this.pending = true;
        requestAnimationFrame(() => {
          this.pending = false;
          this.sync();
        });
      }, { passive: true });

      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.sync(), 100);
      }, { passive: true });

      this.sync();
    }

    step(direction) {
      const item = this.viewport.querySelector('.rail__item');
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.viewport).columnGap) || 0;
      this.viewport.scrollBy({ left: (item.getBoundingClientRect().width + gap) * direction, behavior: 'smooth' });
    }

    /* The bar's fill is the share of the track currently in view, so it
       starts part-filled (one screen of cards) and reaches the end at the
       last card, as on the reference. */
    sync() {
      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      if (this.foot) this.foot.hidden = max <= 1;
      if (max <= 1) return;
      const share = (this.viewport.scrollLeft + this.viewport.clientWidth) / this.viewport.scrollWidth;
      if (this.fill) this.fill.style.transform = `scaleX(${Math.max(0, Math.min(1, share)).toFixed(4)})`;
      if (this.prev) this.prev.disabled = this.viewport.scrollLeft <= 1;
      if (this.next) this.next.disabled = this.viewport.scrollLeft >= max - 1;
    }
  }

  if (!customElements.get('product-rail')) {
    customElements.define('product-rail', ProductRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cta"] && !Shopify.designMode) return;
  try {
    
  class StickyCta extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-scta-button]');
      this.messages = Array.from(this.querySelectorAll('[data-scta-message]'));
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if ('ResizeObserver' in window) {
        new ResizeObserver(() => this.publishHeight()).observe(this);
      }

      // Shown only past the first fold.
      this.shown = false;
      window.addEventListener('scroll', () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.toggle();
        });
      }, { passive: true });
      window.addEventListener('resize', () => this.toggle(), { passive: true });
      this.toggle();

      if (this.messages.length > 1 && !this.reduceMotion.matches) {
        this.index = 0;
        this.timer = window.setInterval(() => this.rotate(), 3000);
      }

      if (this.button) this.button.addEventListener('click', () => this.act());

      this.timerEl = this.querySelector('[data-scta-timer]');
      if (this.timerEl && this.dataset.timerTarget) this.startTimer();

      this.label = this.querySelector('[data-scta-label]');
      this.labelText = this.querySelector('[data-scta-label-text]');
      if (this.label && this.labelText) {
        this.fitLabel();
        window.addEventListener('resize', () => this.fitLabel(), { passive: true });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.fitLabel());
      }
    }

    /* A label wider than its pill scrolls inside it; one that fits stays put. */
    fitLabel() {
      const overflow = this.labelText.scrollWidth - this.labelText.parentElement.clientWidth;
      if (overflow > 1 && !this.reduceMotion.matches) {
        this.label.style.setProperty('--scta-marquee', overflow + 'px');
        this.label.classList.add('is-marquee');
      } else {
        this.label.classList.remove('is-marquee');
      }
    }

    /* Daily countdown in store time. The target is a time of day (HH:MM).
       After it passes, the timer stays hidden for the cooldown, then shows
       again counting down to the next day's target — so with a two-hour
       cooldown the visible run is twenty-two hours, and nobody watching it
       reach zero sees it snap straight back to the top. */
    startTimer() {
      const [hh, mm] = this.dataset.timerTarget.split(':').map((n) => parseInt(n, 10));
      if (isNaN(hh) || isNaN(mm)) return;
      const cooldownMs = (parseFloat(this.dataset.timerCooldown) || 0) * 3600000;
      const offset = /^([+-])(\d\d)(\d\d)$/.exec(this.dataset.storeOffset || '');
      const offsetMs = offset
        ? (offset[1] === '-' ? -1 : 1) * (parseInt(offset[2], 10) * 60 + parseInt(offset[3], 10)) * 60000
        : -new Date().getTimezoneOffset() * 60000;
      const day = 86400000;
      this.digits = Array.from(this.timerEl.querySelectorAll('[data-d]'));
      this.lastShown = this.digits.map(() => '');

      const tick = () => {
        const nowStore = Date.now() + offsetMs;
        const midnight = Math.floor(nowStore / day) * day;
        let target = midnight + (hh * 60 + mm) * 60000;
        if (nowStore >= target) target += day;
        const previous = target - day;

        if (nowStore < previous + cooldownMs) {
          this.timerEl.hidden = true;
          return;
        }
        this.timerEl.hidden = false;

        const remaining = Math.max(0, target - nowStore);
        const h = Math.floor(remaining / 3600000);
        const m = Math.floor((remaining % 3600000) / 60000);
        const sec = Math.floor((remaining % 60000) / 1000);
        const text = [h, m, sec].map((n) => String(n).padStart(2, '0')).join('');
        this.digits.forEach((el, i) => {
          if (this.lastShown[i] === text[i]) return;
          this.lastShown[i] = text[i];
          el.textContent = text[i];
          // Roll the new digit up into place.
          el.classList.remove('is-roll');
          void el.offsetWidth;
          el.classList.add('is-roll');
        });
        this.timerEl.toggleAttribute('data-urgent', remaining < 3600000);
      };
      tick();
      this.timerInterval = window.setInterval(tick, 1000);
    }

    disconnectedCallback() {
      if (this.timer) window.clearInterval(this.timer);
      if (this.timerInterval) window.clearInterval(this.timerInterval);
      document.documentElement.style.removeProperty('--sticky-cta-h');
      document.body.style.paddingBottom = '';
    }

    /* The fold: the bottom of the banner or hero section, else one screen. */
    foldY() {
      const fold = document.querySelector('.banner-section, .hero-section');
      if (fold) return fold.getBoundingClientRect().bottom + window.scrollY;
      return window.innerHeight;
    }

    toggle() {
      const show = window.scrollY > this.foldY() - 40;
      if (show === this.shown) return;
      this.shown = show;
      this.toggleAttribute('data-shown', show);
      this.publishHeight();
    }

    /* While shown, reserve the bar's height at the foot of the page and tell
       the WhatsApp button and video bubble how far up to sit. */
    publishHeight() {
      const height = this.shown ? this.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--sticky-cta-h', height + 'px');
      document.body.style.paddingBottom = height + 'px';
    }

    rotate() {
      this.messages[this.index].classList.remove('is-current');
      this.index = (this.index + 1) % this.messages.length;
      this.messages[this.index].classList.add('is-current');
    }

    act() {
      if (this.dataset.mode === 'link') {
        window.location.href = this.dataset.href;
        return;
      }
      this.checkout();
    }

    /* Same handover as the cart's checkout button (cart-drawer.liquid): the
       Fastrr payload for this one variant, InitiateCheckout / begin_checkout
       at the click, and a 15-second wait for Fastrr's script if it isn't
       ready yet — never a fall-through to Shopify's own checkout. */
    checkout() {
      const read = (selector) => {
        const node = this.querySelector(selector);
        if (!node) return null;
        try { return JSON.parse(node.textContent); } catch (error) { return null; }
      };
      const payload = read('[data-scta-payload]');
      if (!payload) return;

      const tracking = read('[data-scta-tracking]');
      if (typeof window.fbq === 'function' && tracking) {
        window.fbq('track', 'InitiateCheckout', { currency: tracking.currency, value: tracking.value });
      }
      if (typeof window.gtag === 'function' && tracking) {
        window.gtag('event', 'begin_checkout', { currency: tracking.currency, value: tracking.value, items: tracking.items });
      }

      const button = this.button;
      const label = button.querySelector('.scta__label');
      const originalLabel = label.textContent;
      const deadline = Date.now() + 15000;

      const attempt = () => {
        if (window.shiprocketCheckoutEvents?.buyDirect) {
          window.shiprocketCheckoutEvents.buyDirect(payload);
          return;
        }
        if (Date.now() > deadline) {
          button.disabled = false;
          label.textContent = originalLabel;
          alert(button.dataset.labelError || 'Unable to start checkout. Please try again.');
          return;
        }
        button.disabled = true;
        label.textContent = button.dataset.labelLoading || 'Opening checkout…';
        setTimeout(attempt, 150);
      };
      attempt();
    }
  }

  if (!customElements.get('sticky-cta')) {
    customElements.define('sticky-cta', StickyCta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["view-read"] && !Shopify.designMode) return;
  try {
    
  class ViewRead extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-vr-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-vr-panel]'));
      this.ink = this.querySelector('.vr__ink');

      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab.dataset.vrTab)));
      window.addEventListener('resize', () => this.moveInk(), { passive: true });
      requestAnimationFrame(() => this.moveInk());

      // Cards unfold on tap, click or Enter.
      this.querySelectorAll('[data-vr-card]').forEach((card) => {
        const toggle = () => card.classList.toggle('is-open');
        card.addEventListener('click', (event) => {
          if (event.target.closest('a')) return;
          toggle();
        });
        card.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggle(); }
        });
      });
    }

    select(name) {
      this.tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.vrTab === name)));
      this.panels.forEach((panel) => {
        const active = panel.dataset.vrPanel === name;
        panel.hidden = !active;
        if (!active) panel.querySelectorAll('video').forEach((v) => v.pause());
      });
      this.moveInk();
      const rail = this.querySelector(`[data-vr-panel="${name}"] snap-rail`);
      if (rail && rail.sync) rail.sync();
    }

    moveInk() {
      const active = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
      if (!active || !this.ink) return;
      this.ink.style.width = active.offsetWidth + 'px';
      this.ink.style.transform = `translateX(${active.offsetLeft}px)`;
    }
  }

  if (!customElements.get('view-read')) {
    customElements.define('view-read', ViewRead);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["visual-breaker"] && !Shopify.designMode) return;
  try {
    
  class FilmPlayer extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-film-mute]');
      this.label = this.querySelector('[data-film-mute-label]');
      this.icon = this.querySelector('.film__mute-icon');
      if (!this.button) return;

      const videos = this.querySelectorAll('video');
      if (!videos.length) {
        this.button.hidden = true;
        return;
      }

      this.button.addEventListener('click', () => {
        videos.forEach((v) => {
          v.muted = !v.muted;
          if (!v.muted) v.play().catch(() => {});
        });
        const muted = videos[0].muted;
        this.button.setAttribute('aria-pressed', String(muted));
        if (this.icon) this.icon.textContent = muted ? '🔇' : '🔊';
        if (this.label) {
          this.label.textContent = muted
            ? this.label.dataset.unmute || 'Unmute video'
            : this.label.dataset.mute || 'Mute video';
        }
      });
    }
  }

  if (!customElements.get('film-player')) {
    customElements.define('film-player', FilmPlayer);
  }

  } catch(e) { console.error(e); }
})();
})();
